<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
/**
 * Dashboard Component
 */
export default {
  name: 'crm.dashboard',
  page: {
    title: 'Sales - Dashboard',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data () {
    return {
      title: 'Sales Dashboard'
    }
  },

  computed: {
    breadcrumbs () {
      return [
        {
          text: 'Sales',
          to: { name: 'sales' }
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbs" />

    <!-- end row -->
  </Layout>
</template>
